"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const WebSocket = require("isomorphic-ws");
const ksuid_1 = __importDefault(require("ksuid"));
const p_queue_1 = __importDefault(require("p-queue"));
const debug_1 = __importDefault(require("debug"));
const trace = debug_1.default("@oada/client:ws:trace");
const error = debug_1.default("@oada/client:ws:error");
const request_1 = require("@oada/types/oada/websockets/request");
const response_1 = require("@oada/types/oada/websockets/response");
const change_1 = require("@oada/types/oada/websockets/change");
const v2_1 = require("@oada/types/oada/change/v2");
var ConnectionStatus;
(function (ConnectionStatus) {
    ConnectionStatus[ConnectionStatus["Disconnected"] = 0] = "Disconnected";
    ConnectionStatus[ConnectionStatus["Connecting"] = 1] = "Connecting";
    ConnectionStatus[ConnectionStatus["Connected"] = 2] = "Connected";
})(ConnectionStatus || (ConnectionStatus = {}));
class WebSocketClient {
    constructor(domain, concurrency = 10) {
        this._domain = domain;
        this._requests = new Map();
        this._status = ConnectionStatus.Connecting;
        this._ws = new Promise((resolve) => {
            const ws = new WebSocket("wss://" + this._domain);
            ws.onopen = () => {
                this._status = ConnectionStatus.Connected;
                resolve(ws);
            };
            ws.onclose = () => {
                this._status = ConnectionStatus.Disconnected;
            };
            ws.onmessage = this._receive.bind(this);
        });
        this._q = new p_queue_1.default({ concurrency });
        this._q.on("active", () => {
            trace(`WS Queue. Size: ${this._q.size} pending: ${this._q.pending}`);
        });
    }
    async disconnect() {
        if (this._status == ConnectionStatus.Disconnected) {
            return;
        }
        (await this._ws).close();
    }
    isConnected() {
        return this._status == ConnectionStatus.Connected;
    }
    request(req, callback, timeout) {
        return this._q.add(() => this.doRequest(req, callback, timeout));
    }
    async doRequest(req, callback, timeout) {
        const requestId = req.requestId || ksuid_1.default.randomSync().string;
        req.requestId = requestId;
        request_1.assert(req);
        (await this._ws).send(JSON.stringify(req));
        const request_promise = new Promise((resolve, reject) => {
            this._requests.set(requestId, {
                resolve,
                reject,
                settled: false,
                persistent: callback ? true : false,
                callback,
            });
        });
        if (timeout && timeout > 0) {
            const timeout_promise = new Promise((resolve, reject) => {
                setTimeout(() => {
                    const request = this._requests.get(requestId);
                    if (request && !request.settled) {
                        request.reject("Request timeout");
                        this._requests.delete(requestId);
                    }
                    reject("Request timeout");
                }, timeout);
            });
            return Promise.race([request_promise, timeout_promise]);
        }
        else {
            return request_promise;
        }
    }
    _receive(m) {
        try {
            const msg = JSON.parse(m.data.toString());
            let requestIds;
            if (Array.isArray(msg.requestId)) {
                requestIds = msg.requestId;
            }
            else {
                requestIds = [msg.requestId];
            }
            for (const requestId of requestIds) {
                let request = this._requests.get(requestId);
                if (request) {
                    if (response_1.is(msg)) {
                        if (!request.callback) {
                            this._requests.delete(requestId);
                        }
                        if (!request.settled) {
                            request.settled = true;
                            if (msg.status && msg.status >= 200 && msg.status < 300) {
                                request.resolve(msg);
                            }
                            else if (msg.status) {
                                request.reject(msg);
                            }
                            else {
                                throw new Error("Request failed");
                            }
                        }
                    }
                    else if (request.callback && change_1.is(msg)) {
                        v2_1.assert(msg.change);
                        const m = {
                            requestId: msg.requestId,
                            resourceId: msg.resourceId,
                            path_leftover: msg.path_leftover,
                            change: msg.change.map((_a) => {
                                var { body } = _a, rest = __rest(_a, ["body"]);
                                return Object.assign(Object.assign({}, rest), { body: body });
                            }),
                        };
                        request.callback(m);
                    }
                    else {
                        throw new Error("Invalid websocket payload received");
                    }
                }
            }
        }
        catch (e) {
            error(`[Websocket ${this._domain}] Received invalid response. Ignoring.`);
            trace(`[Websocket ${this._domain}] Received invalid response. %O`, e);
        }
    }
}
exports.WebSocketClient = WebSocketClient;
//# sourceMappingURL=websocket.js.map
